import { Button, Form, Input, Select, message } from 'antd';
import { useGetFeedbackTypesQuery, usePostFeedbackDataMutation } from '../slice/createContactUsApiSlice';
import { useEffect, useState } from 'react';
import { feedbackFormFace } from '../../../shared/utils/interfaces/AuthInterface';
import { formHasErrors } from '../../../shared/utils/functions/handleFormChanges';
import { errorMessage } from '../../../shared/utils/constantData';
import { getImageUrl } from '../../../shared/utils/functions/images';

export default function SendFeedbackForm({ afterSubmit }: { afterSubmit: () => void }) {
    const { Option } = Select;
    const [form] = Form.useForm();
    const [postFeedbackData, { data, isLoading, isSuccess, isError, reset }] = usePostFeedbackDataMutation();
    const { data: feedbackTypesData, isLoading: typesIsLoading } = useGetFeedbackTypesQuery();
    const [isDisabled, setIsDisabled] = useState(true);

    useEffect(() => {
        if (isSuccess) {
            message.success(data?.message)
            afterSubmit();
            form.resetFields();
        }
        else if (isError) {
            message.error(errorMessage)
        }
        return () => {
            setIsDisabled(true)
            reset()
        }
    }, [afterSubmit, data, form, isSuccess, isError, reset]);

    const onFinish = async (values: feedbackFormFace) => {
        await postFeedbackData(values);
    }
    const handleFormChange = () => {
        setIsDisabled(formHasErrors(form));
    }

    return (
        <Form
            form={form}
            className='text-start'
            size='large'
            onFinish={onFinish}
            onFieldsChange={handleFormChange}
        >
            <Form.Item
                name="feedbackType"
                rules={[{ required: true, message: 'Feedback Type is missing' }]}
            >
                <Select
                    loading={typesIsLoading}
                    className='w-full text-sm font-normal text-gray-600 placeholder-gray-400 capitalize'
                    placeholder="Select feedback type"
                    suffixIcon={<img src={getImageUrl('ChevronDown')} alt='Arrow Down' />}
                >
                    {feedbackTypesData?.feedbackTypes?.map((type: string, key: number) => {
                        return (<Option key={key} value={type}>{type}</Option>)
                    })}
                </Select>
            </Form.Item>
            <Form.Item
                name="comment"
                rules={[{ required: true, message: 'Feedback is missing' }]}
            >
                <Input.TextArea placeholder='Write your feedback here' rows={5} />
            </Form.Item>
            <Form.Item
                className='mb-0'
            >
                <Button
                    loading={isLoading}
                    disabled={isDisabled}
                    className="w-full btn-primary btn-lg"
                    htmlType='submit'
                >
                    Send Feedback
                </Button>
            </Form.Item>
        </Form>
    )
}